<template>
  <v-dialog width="600" persistent @input="onClose" :value="value" scrollable :color="color">
    <v-card class="text-center">
      <v-card-title>
        <v-spacer />
        <v-btn icon @click="onClose()"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="px-2 px-sm-6">
        <v-row justify="center">
          <v-col cols="6" v-for="(product, index) in productDetails" :key="index">
            <v-hover v-slot="{hover}">
              <v-card
                class="productCard rounded-lg py-10"
                :elevation="hover ? 16 : 2"
                :class="{'on-hover': hover}"
                @click="productLink(product)"
                color="grey darken-4"
              >
                <v-img
                  style="margin: auto"
                  width="80"
                  height="80"
                  class="mb-2"
                  :src="require(`@/assets/icons/${product.icon}`)"
                  :lazy-src="require(`@/assets/icons/${product.icon}`)"
                ></v-img>
                <v-card-actions class="justify-center py-4">
                  <v-btn rounded outlined :x-small="$vuetify.breakpoint.xsOnly">Get For {{ product.title }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="10">
            <h2>{{ title }}</h2>
            <v-card-text>
              <p class="grey--text">{{ text }}</p>
              <v-btn class="py-6" rounded outlined @click="productHuntUrl">
                <v-img
                  width="180"
                  :src="require(`@/assets/icons/product-hunt-logo.svg`)"
                  :lazy-src="require(`@/assets/icons/product-hunt-logo.svg`)"
                ></v-img>
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true,
    },
    text: {
      type: String,
      require: true,
    },
    value: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
    },
  },
  data: () => ({
    productDetails: [
      {
        title: 'Adobe XD',
        icon: 'adobexd.svg',
        url: 'https://exchange.adobe.com/apps/cc/2418aad9?pluginId=2418aad9&workflow=share',
      },
      {
        title: 'Figma',
        icon: 'figma.svg',
        url: 'https://www.figma.com/c/plugin/749945157855564842/User-Profile',
      },
    ],
  }),
  methods: {
    onClose() {
      this.$emit('dismissed')
    },
    productLink(event) {
      this.$gtag.event(`${event.title.toLowerCase()} selected`, {
        event_category: 'product-selected-click',
        event_label: 'Selected product from dialog',
        value: 1,
      })
      window.open(event.url, '_blank')
    },
    productHuntUrl() {
      this.$gtag.event('producthunt click', {
        event_category: 'producthunt-click',
        event_label: 'Clicked on producthunt button from dialog',
        value: 1,
      })
      window.open('https://www.producthunt.com/posts/user-profile-plugin-0-5v-for-adobe-xd', '_blank')
    },
  },
}
</script>

<style scoped>
.productCard {
  transition: opacity 0.2s ease-in-out;
}
.productCard:not(.on-hover) {
  opacity: 0.6;
}
</style>
